import { useState, useEffect } from 'react';
import { registerPanel, closeOtherPanels } from './panelCoordinator';

let listeners = [];
let openCount = 0;
let state = {
  isOpen: false,
  sheetData: null,
  sheetTitle: null,
  key: 0,
};

const notify = () => listeners.forEach(l => l({ ...state }));

const doOpen = (sheetData, title) => {
  openCount++;
  state = { isOpen: true, sheetData, sheetTitle: title || 'Spreadsheet', key: openCount };
  notify();
};

export const spreadsheetEditor = {
  open: (sheetData, title) => {
    // Same card already open — do nothing
    if (state.isOpen && state.sheetData === sheetData) return;
    const hadOther = closeOtherPanels('spreadsheet');
    // If this panel or another was open, close first then reopen for animation
    if (state.isOpen || hadOther) {
      state = { isOpen: false, sheetData: null, sheetTitle: null };
      notify();
      setTimeout(() => doOpen(sheetData, title), 350);
      return;
    }
    doOpen(sheetData, title);
  },

  close: () => {
    state = { isOpen: false, sheetData: null, sheetTitle: null };
    notify();
  },

  updateData: (sheetData) => {
    state = { ...state, sheetData };
    notify();
  },

  getState: () => ({ ...state }),
};

// Register with coordinator
registerPanel('spreadsheet', () => {
  if (!state.isOpen) return false;
  spreadsheetEditor.close();
  return true;
});

export const useSpreadsheetEditor = () => {
  const [editorState, setEditorState] = useState({ ...state });

  useEffect(() => {
    const handler = (s) => setEditorState(s);
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(l => l !== handler);
    };
  }, []);

  return {
    ...editorState,
    open: spreadsheetEditor.open,
    close: spreadsheetEditor.close,
    updateData: spreadsheetEditor.updateData,
  };
};

export default useSpreadsheetEditor;
